import React,{useEffect} from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import ModalComponent from 'molecules/Modal';
import { ADDRESS_STORE_CONSTANTS, FORM_HEADING } from 'organisms/AccountPage/AU/Constants/Constants';
import { SelectOptions } from 'atoms/DropDown';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { SUB_PREMISE_FILTER } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getAndCheckIfOneTrue } from 'common/utilities/utils';
import clearTextIcon from 'styles/staticAssets/images/clearTextIcon.jpg';
import { getUnitValue } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';

const fetchCountryBasedLoc = (obj, country) => obj.value.toUpperCase() === country;
const addressZeroResults=(status)=>(status?.toUpperCase() === ADDRESS_STORE_CONSTANTS.ZERO_RESULTS ? <div className='noAddressText'>{ADDRESS_STORE_CONSTANTS?.NO_ADDRESS_FOUND}</div> : null)

export const renderSuggestions = params => {
  const { data, status, handleSelect, countryNameInDefaultLang } = params;
  return (
    status?.toUpperCase() === ADDRESS_STORE_CONSTANTS.OK ?
    data?.map(suggestion => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;
      return (
        <>
          {suggestion.terms.filter(term => fetchCountryBasedLoc(term, countryNameInDefaultLang))?.length > 0 && (
            <li
              key={place_id}
              data-testid='address-suggestion-id'
              className='address-suggestion-text'
              onClick={handleSelect(suggestion)}
            >
              <ImageComponent
                srcFile={IMAGE_PATH.SuggestionItemSearchPin}
                alt={'googleMapLocation'}
                className='suggetion-pin'
              />
              <span className='address-text'>
                {main_text} {secondary_text}
              </span>
            </li>
          )}
        </>
      );
    }) : addressZeroResults(status)
  )
};

export const getUnitNumberCheck =(addresses,nonFormattedAddress)=>{
  const { floor, addressLines, isFlatNumberSelected } = addresses; 
  const getUpdateAptNumber = nonFormattedAddress && SUB_PREMISE_FILTER?.some(term => nonFormattedAddress.includes(term));
   if(getUpdateAptNumber && isFlatNumberSelected){
    return getUnitValue(nonFormattedAddress);
   }else{
    return floor || addressLines[0]
   }
}
export const getAddressValue=(addresses,value,nonFormattedAddress)=>{
  const { addressLines } = addresses; 
  if(SUB_PREMISE_FILTER?.some(term => nonFormattedAddress?.includes(term))){
    return nonFormattedAddress
  }
  else{
   return value || addressLines[1]
  }
  
}
export const onKeyPressed = event => {
  event.preventDefault();
  return false;
};

/**
 * The element renders the coupons landing modal with close button
 * @param {*} props
 * @props isOpen: Boolean value to determine if modal is open
 * @props handleClose: Handler function for closing the Modal
 * @returns JSX.Element
 */
export const AddressModal = props => {
  const {
    setValue,
    value,
    isOpen,
    handleClose,
    modalType,
    error,
    addresses,
    handleChange,
    handleInput,
    showSuggestions,
    ready,
    suggestionRef,
    suggestions,
    handleSelect,
    checkFormValidation,
    handleSubmit,
    isNameExist,
    isInvalidName,
    savedAddresses = [],
    isAddressFromOrderProcessing = false,
    countryNameInDefaultLang,
    setSaveAddress,
    nonFormattedAddress,
    setNonFormattedAddress,
  } = props;
  const { data, status } = suggestions;
  const {
    ADD_NEW_ADDRESS,
    EDIT_DELIVERY_ADDRESS,
    NOT_SERVICEABLE,
    SPECIAL_CHAR_ERROR,
    NAME_EXIST_ERROR,
    ADDRESS_ERROR_MSG,
    INITIAL_STATE
  } = ADDRESS_STORE_CONSTANTS;

  const { CANCEL, SAVE, ADDRESS_NICK_NAME, HAND_IT_TO_ME, LEAVE_AT_MY_DOOR, SELECT_ONE, PLEASE_FILL_OUT_THIS_FIELD, DELIVERY_OPTIONS_TOOL_TIP } = TRANSLATE_MAPPING_KEY;

  const {
    ADDRESS,
    APT_SUITE_FLOOR,
    POSTAL_CODE,
    CITY_TOWN,
    MAKE_THIS_DEFAULT_ADD,
    STATE,
    DELIVERY_OPTION,
    DELIVERY_INSTRUCTION,
  } = FORM_HEADING;
  const DELIVERY_OPTIONS = [translateWithI18Next(SELECT_ONE), translateWithI18Next(HAND_IT_TO_ME), translateWithI18Next(LEAVE_AT_MY_DOOR)];
  /**
   * Changing of the props sent to modal component based on screen-width
   */
  const modalProps = {
    id: 'AddressModalPopup',
    role: 'dialog',
    modalTitleId: 'AddressModalPopup',
    show: isOpen,
    classNames: 'address-module-modal edit-addr-model',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: handleClose,
    modalTitle: !modalType ? ADD_NEW_ADDRESS : EDIT_DELIVERY_ADDRESS,
    autoFocus: true,
  };
  
  const handleClearAdresses = () => {
    setSaveAddress(INITIAL_STATE);
    setValue('');
    getUnitNumberCheck(INITIAL_STATE);
    setNonFormattedAddress('')
  }

  useEffect(()=>{
    const getUpdateAptNumber = nonFormattedAddress && SUB_PREMISE_FILTER?.some(term => nonFormattedAddress.includes(term));
    getUpdateAptNumber && nonFormattedAddress &&
    setSaveAddress({
      ...addresses,
      addressLines:[getUnitValue(nonFormattedAddress),nonFormattedAddress]
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[nonFormattedAddress])

  return (
    <ModalComponent {...modalProps} data-testid='address-modal-landing-page'>
      {isNameExist && (
        <div className='addr-error-container'>
          <div className='error-sub-container'>
            <ImageComponent srcFile={IMAGE_PATH.Error} className='mr-1 location-alert-icon' />
            <div className='error-msg'>{translateWithI18Next(ADDRESS_ERROR_MSG)}</div>
          </div>
        </div>
      )}
      <div className='address-form-section'>
        <div className='form-container'>
          {error && <div className='error-service-msg'>{translateWithI18Next(NOT_SERVICEABLE)}</div>}

          <div className='form-header'>{translateWithI18Next(ADDRESS)}</div>
          <form autocomplete='off'>
            <div className={`input-container ${(isNameExist || isInvalidName) && 'error-input-container'}`}>
              <input
                required
                type='text'
                data-testid='name-testid'
                name='name'
                value={addresses?.name}
                onChange={handleChange}
                title={translateWithI18Next(PLEASE_FILL_OUT_THIS_FIELD)}
                className={isNameExist || isInvalidName ? 'error-input' : ''}
                title={translateWithI18Next(PLEASE_FILL_OUT_THIS_FIELD)}
              />
              <label>{translateWithI18Next(ADDRESS_NICK_NAME)}</label>
              {(isNameExist || isInvalidName) && (
                <div className='error-text-container'>
                  <ImageComponent srcFile={IMAGE_PATH.Error} />
                  <span className='error-text'>
                    {translateWithI18Next(isInvalidName ? SPECIAL_CHAR_ERROR : NAME_EXIST_ERROR)}
                  </span>
                </div>
              )}
            </div>

            <div className='input-container'>
              {(value || addresses?.addressLines[1]) && <div className='remove-container' onClick={()=>handleClearAdresses()}  data-testid='clear-text-icon'>
              <img
                alt={''}
                src={clearTextIcon}
              />
              </div>}
              <input
                data-testid='search-input-address'
                value={getAddressValue(addresses,value,nonFormattedAddress)}
                onChange={handleInput}
                disabled={!ready}
                name='addressLine'
                onFocus={() => setValue(value)}
                required
                type='text'
              />
              <label>{translateWithI18Next(ADDRESS)}*</label>
              {showSuggestions &&  <ul ref={suggestionRef} className='address-list'>
                {renderSuggestions({ data, status, handleSelect, countryNameInDefaultLang })}
              </ul>}
             
            </div>

            <div className='d-flex adjust-width flex-dir'>
              <div className='input-container'>
                <input
                  required
                  type='text'
                  name='floor'
                  value={getUnitNumberCheck(addresses,nonFormattedAddress)}
                  onChange={handleChange}
                  data-testid='floor-test-id'
                />
                <label>{translateWithI18Next(APT_SUITE_FLOOR)}</label>
              </div>
              <div className='input-container ml5'>
                <input
                  required
                  type='text'
                  name='pinCode'
                  onKeyDown={event => onKeyPressed(event)}
                  onKeyPress={event => onKeyPressed(event)}
                  value={addresses?.pinCode}
                  tabIndex='-1'
                  data-testid='pincode-id'
                  onChange={handleChange}
                />
                <label>{translateWithI18Next(POSTAL_CODE)}*</label>
              </div>
            </div>

            <div className='d-flex adjust-width flex-dir'>
              <div className='input-container'>
                <input
                  required
                  type='text'
                  tabIndex='-1'
                  name='city'
                  onKeyDown={event => onKeyPressed(event)}
                  onKeyPress={event => onKeyPressed(event)}
                  value={addresses?.city}
                  data-testid='city-id'
                  onChange={handleChange}
                />
                <label>{translateWithI18Next(CITY_TOWN)}*</label>
              </div>
              <div className='input-container ml5'>
                <input
                  required
                  type='text'
                  tabIndex='-1'
                  name='state'
                  onKeyDown={event => onKeyPressed(event)}
                  onKeyPress={event => onKeyPressed(event)}
                  value={addresses?.state}
                  data-testid='state-id'
                  onChange={handleChange}
                />
                <label>{translateWithI18Next(STATE)}*</label>
              </div>
            </div>

            <div className='d-flex adjust-width flex-dir'>
              <div className='input-container'>
                <SelectOptions
                  options={DELIVERY_OPTIONS}
                  selectClassName='select-deliveryOptions-selection'
                  optionContainerClassName='select-deliveryOptions-option-conatiner'
                  optionClassName='select-deliveryOptions-option'
                  onChange={handleChange}
                  testid='select-deliveryOptions'
                  name='deliveryOptions'
                  required
                  selectedValue={addresses?.deliveryOptions}
                  title={translateWithI18Next(DELIVERY_OPTIONS_TOOL_TIP)}
                />
                <label>{translateWithI18Next(DELIVERY_OPTION)}*</label>
              </div>
              <div className='input-container ml5'>
                <input
                  required
                  type='text'
                  name='deliveryInstructions'
                  value={addresses?.deliveryInstructions}
                  data-testid='deliveryInstruction-id'
                  onChange={handleChange}
                  maxlength="100"
                />
                <label>{translateWithI18Next(DELIVERY_INSTRUCTION)}</label>
              </div>
            </div>
            <div className='default-address-section'>
              <input
                type='checkbox'
                name='isPrimary'
                data-testid='default-testid'
                id='default-address'
                value={addresses?.isPrimary}
                checked={getAndCheckIfOneTrue(
                  addresses?.isPrimary,
                  savedAddresses.length < 1 || (modalType && savedAddresses.length <= 1),
                )}
                onChange={handleChange}
                disabled={savedAddresses.length < 1 || (modalType && savedAddresses.length <= 1)}
              />
              <div className='default-label-text'>
                <label htmlFor='default-address'>{translateWithI18Next(MAKE_THIS_DEFAULT_ADD)}</label>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='text-center input-container'>
        <ButtonComp
          onClick={handleClose}
          data-testid='close-testid'
          className={`mt-10 button font-bold whiteButton blackBorder`}
        >
          {translateWithI18Next(CANCEL)}
        </ButtonComp>
        <ButtonComp
          disabled={!checkFormValidation() || error}
          className={`mt-10 button font-bold whiteButton blkColor ml5`}
          data-testid='submit-testid'
          onClick={() => {
            handleSubmit(isAddressFromOrderProcessing);
          }}
        >
          {translateWithI18Next(SAVE)}
        </ButtonComp>
      </div>
    </ModalComponent>
  );
};

export default AddressModal;
